/** @type {Record<string, string | Record<string, string>>} */
const strings = {
  nav: {
    command: 'Command',
    calendar: 'Calendar',
    onlineBookings: 'Online',
    pos: 'POS',
    guests: 'Guests',
    team: 'Team',
    insights: 'Insights',
  },
  auth: {
    email: 'Email',
    password: 'Password',
    rememberMe: 'Remember me',
    signIn: 'Sign in',
    signingIn: 'Signing in…',
    twoFactorTitle: 'Two-factor authentication',
    twoFactorHint: 'Enter the code from your authenticator app',
    twoFactorHintRecovery: 'Enter the code from your authenticator app or a recovery code.',
    recoveryCode: 'Recovery code',
    authCode: 'Authentication code',
    continue: 'Continue',
    verifying: 'Verifying…',
    useRecoveryCode: 'Use a recovery code',
    useAuthenticatorCode: 'Use authenticator code',
    backToSignIn: 'Back to sign in',
  },
  common: {
    search: 'Search…',
    searchCatalog: 'Search catalog items',
    notifications: 'Notifications',
    language: 'Language',
    english: 'English',
    arabic: 'Arabic',
    loading: 'Loading…',
  },
  search: {
    title: 'Search menu',
    open: 'Open menu search',
    placeholder: 'Search pages and settings…',
    placeholderShort: 'Search menu…',
    noResults: 'No matching menu items',
    groups: {
      main: 'Main menu',
      admin: 'Administration',
      masters: 'Masters & catalog',
      workspace: 'Workspace',
    },
  },
  notifications: {
    title: 'Notifications',
    new: 'New',
    newCountLabel: 'new',
    unreadLabel: 'unread',
    empty: "You're all caught up",
    emptyHint: 'New online bookings will appear here.',
    onlineBooking: 'Online booking request',
    guestFallback: 'Guest',
    viewAll: 'View all online bookings',
    needsApproval: 'Review',
    loading: 'Loading notifications…',
    toastTitle: 'New online booking',
    toastAction: 'Tap to review',
    dismiss: 'Dismiss',
  },
  pos: {
    services: 'Services',
    quickKeys: 'Quick keys',
    retail: 'Retail',
    categories: 'Categories',
    genderPricing: 'Gender pricing and catalog filter',
    ladies: 'Ladies',
    gents: 'Gents',
    allCategories: 'All categories',
    ticket: 'Ticket',
    ticketSummary: 'Ticket · {{lines}} · {{minutes}}m',
    loadTicket: 'Load ticket',
    loadAppointment: 'Load appt',
    shortcuts: {
      customer: 'Customer',
      appointment: 'Appt',
      pay: 'Pay',
      hold: 'Hold',
      package: 'Package',
      redeem: 'Redeem',
      recall: 'Recall',
      qty: 'Qty',
      close: 'Close',
    },
  },
  publicBook: {
    currency: 'AED {{amount}}',
    schedule: {
      today: 'Today',
      tomorrow: 'Tomorrow',
      morning: 'Morning',
      afternoon: 'Afternoon',
      evening: 'Evening',
    },
    hub: {
      eyebrow: 'Online Booking',
      title: 'Choose a salon',
      errorLoad: 'Unable to load booking locations.',
      fallbackTagline: 'BOOK & RELAX',
    },
    home: {
      unavailable: 'This booking page is not available.',
      welcome: 'Welcome To',
      viewCatalog: 'View Catalog',
      contact: 'Contact',
      phone: 'Phone',
      whatsapp: 'WhatsApp',
      address: 'Address',
      directions: 'Directions',
      openMaps: 'Open in maps',
      logoAlt: '{{name}} logo',
    },
    catalog: {
      unavailable: 'This booking page is not available.',
      catalog: 'Catalog',
      book: 'Book',
      searchPlaceholder: 'Search services…',
      filterCategories: 'Filter Categories',
      done: 'Done',
      allCategories: 'All Categories',
      checkoutBar: '{{count}} service{{suffix}}',
      checkoutTotal: 'Checkout · {{total}}',
      home: 'Home',
    },
    cart: {
      title: 'Your cart',
      editHint: 'Edit quantities or remove items before checkout',
      reviewHint: 'Review services for {{branch}}',
      close: 'Close',
      empty: 'Your cart is empty.',
      each: '{{price}} each',
      remove: 'Remove',
      quantity: 'Quantity',
      totalItems: 'Total items',
      itemCount: '{{count}} item{{suffix}}',
      subtotal: 'Subtotal (ex VAT)',
      vat: 'VAT (UAE 5%)',
      totalIncVat: 'Total (inc VAT)',
      continue: 'Continue to details',
    },
    checkout: {
      details: 'Booking details',
      verifyPhone: 'Verify phone',
      confirmed: 'Booking confirmed',
      close: 'Close',
      manageLink: 'Manage your booking',
      addCalendar: 'Add to calendar (.ics)',
      done: 'Done',
      otpPrompt: 'Enter the 6-digit code sent{{channel}} to {{phone}}.',
      otpChannelWhatsApp: ' on WhatsApp',
      devCode: 'Dev code: {{code}}',
      back: 'Back',
      verifying: 'Verifying…',
      verifyBook: 'Verify & book',
      contactDetails: 'Contact details',
      name: 'Name',
      namePlaceholder: 'Your name',
      phone: 'Phone',
      phoneHintUae: 'Enter a mobile starting with 5 (e.g. 50 123 4567), without the leading 0.',
      phoneHintDefault: 'Enter the full mobile number without the leading 0.',
      whatsappOtpHint: "We'll send your verification code on WhatsApp to this number.",
      pickDay: 'Pick a day',
      completePhoneFirst: 'Complete your phone number first.',
      availableTimes: 'Available times',
      openSlots: '{{count}} open',
      noTimesDay: 'No times on this day. Try another date.',
      allBooked: 'All times are booked or too soon. Pick another date.',
      notes: 'Notes (optional)',
      notesPlaceholder: 'Any preferences or requests',
      manualReview: '{{branch}} reviews online requests before confirming.',
      backToCart: 'Back to cart',
      pleaseWait: 'Please wait…',
      sendWhatsAppCode: 'Send WhatsApp code & continue',
      sendCode: 'Send code & continue',
      confirmBooking: 'Confirm booking',
      errorLoadSlots: 'Unable to load available times.',
      errorPhone: 'Enter your full mobile number including country code.',
      errorSendWhatsApp: 'Unable to send WhatsApp verification code.',
      errorSendCode: 'Unable to send verification code.',
      errorVerify: 'Incorrect verification code.',
      errorSubmit: 'Unable to submit booking.',
      codeSent: 'Verification code sent.',
      icsTitle: '{{branch}} appointment',
      icsDescription: 'Manage booking: {{url}}',
      icsFallback: 'Online booking',
    },
    manage: {
      expired: 'This booking link has expired or is invalid.',
      backHub: 'Back to booking hub',
      loading: 'Loading your booking…',
      allBranches: 'All branches',
      title: 'Manage booking',
      when: 'When',
      guest: 'Guest',
      guestFallback: 'Guest',
      services: 'Services',
      reschedule: 'Reschedule',
      saving: 'Saving…',
      saveTime: 'Save new time',
      cancelling: 'Cancelling…',
      cancelAppointment: 'Cancel appointment',
      confirmCancel: 'Cancel this appointment?',
      changesClosed: 'Online changes are closed within {{hours}} hours of your appointment. Contact the salon directly if you need help.',
      errorCancel: 'Unable to cancel booking.',
      errorReschedule: 'Unable to reschedule.',
    },
    aria: {
      goBack: 'Go back',
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
      closeMenuBackdrop: 'Close menu backdrop',
      search: 'Search',
      filter: 'Filter',
      closeCart: 'Close cart',
      closeCheckout: 'Close checkout',
    },
  },
}

export default strings
